import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';

import styled from 'styled-components';
import Popover from "@mui/material/Popover";
import copyIcon from "../../../img/copy-icon.svg";
import { copyToClipBoard } from "../../../utils";

import { useGetAllStrategyTypesQuery } from '../../../services/strategyTypesApi.js';
import { useBuyManagers } from '../../../customHooks/useBuyManagers.js';
import SignalREncorehiveContext from '../../../context/signalREncorehive';
import useSwarmColumns from './hooks/useSwarmColumns';
import SwarmEditModal from '../../AdminSwarm2.0/features/activeSwarms/components/EditEvent/SwarmEditModal';
import { useNotification } from '@/context/NotificationContext';
import useSwarmOperations from './hooks/useSwarmOperations';
import CreateSwarmsFilters from './components/CreateSwarmsFilters';
import useFilters from './hooks/useFilters';

export default function CreateSwarmsRefactor() {

  const { showNotification } = useNotification();
  
  //A: inside the rtk query dispatch an action to load in the redux store the strategys types
  useGetAllStrategyTypesQuery();
  useBuyManagers();

  const [runId, setRunId] = useState(null);
  const [anchorEl, setAnchorEl] = useState();
  const [showRunID, setShowRunID] = useState(false);
  
  // State for the SwarmEditModal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSwarm, setSelectedSwarm] = useState(null);
  async function getRunID(event, id) {
    
    const idField = event.currentTarget.id;
    const field = document.getElementById(idField);

    setRunId(id); 
    setAnchorEl(field);
    setShowRunID(!showRunID);
  }

  const BorderPopover = styled(Popover)({
    "& .MuiPopover-paper": {
      height: "fit-content",
      marginLeft: '1.5em',
    },
  });
  const { signalREncorehive } = useContext(SignalREncorehiveContext);

  // const classes = useStyles(); // styles for the component
  const [rows, setRows] = useState([]);
  useEffect(() => {
    console.log('ROWS UPDATED: ', rows)
  }, [rows]);

  //A: here we saved the api result for getSwarmEvents, and later we can update here when the user edit the events.
  const [localEvents, setLocalEvents] = useState([]);


  const handleColumnResize = (params) => {  
    const savedColumnWidths = JSON.parse(sessionStorage.getItem('columnWidths')) || {};
      savedColumnWidths[params.colDef.field] = params.width;
      sessionStorage.setItem('columnWidths', JSON.stringify(savedColumnWidths));
  };  

  const [rowModesModel, setRowModesModel] = useState({});
  const { filters, setFilters, paginationModel, setPaginationModel, hiddenEvents, onShowHideEventClicked, onSearch, loadingEvents, swarmEventsRes, errorGettingSwarms, swarmsQueryData, ErrorLoadingEvents } = useFilters({setLocalEvents});
  const { startSwarm, stopSwarm, processRowUpdate, swarmsUpdating } = useSwarmOperations({setRows, setLocalEvents, localEvents, hiddenEvents, rowModesModel, setRowModesModel, loadingEvents, swarmEventsRes, errorGettingSwarms, swarmsQueryData, ErrorLoadingEvents});

  // Handler for opening the Autobuy modal
  const handleOpenAutobuyModal = useCallback((swarm) => {
    setSelectedSwarm(swarm);
    setIsModalOpen(true);
  }, []);

  // Handler for closing the modal
  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedSwarm(null);
  }, []);
  
  // Effect to keep selectedSwarm updated when rows change
  useEffect(() => {
    if (selectedSwarm && isModalOpen) {
      // Find the updated row in rows using the bteId
      const updatedSwarm = rows.find(row => row.bteId === selectedSwarm.bteId);
      
      if (updatedSwarm && JSON.stringify(updatedSwarm) !== JSON.stringify(selectedSwarm)) {
        // Only update if there are actual changes
        console.log('Updating selectedSwarm with fresh data from rows');
        setSelectedSwarm(updatedSwarm);
      }
    }
  }, [rows, selectedSwarm, isModalOpen]);

  const { getColumns } = useSwarmColumns({
    startSwarm,
    stopSwarm,
    rowModesModel,
    swarmsUpdating,
    processRowUpdate,
    onOpenAutobuyModal: handleOpenAutobuyModal
  });

  useEffect(() => {
    if (!signalREncorehive) return;
  
    const handleUpdateEvent = (eventModel) => {
      setLocalEvents(prevEvents =>
        prevEvents.map(e =>
          e.bteId === eventModel.bteId ? eventModel : e
        )
      );
    };
  
    signalREncorehive.on('UpdateEvent', handleUpdateEvent);
  
    return () => {
      signalREncorehive.off('UpdateEvent', handleUpdateEvent);
    };
  }, [signalREncorehive]);

  const handleProcessRowUpdateError = useCallback((error) => {
    console.log("error handleProcessRowUpdateError: ", error)
    showNotification('Error editing Swarm Code: ' + error?.data?.correlationId, 'error');
  }, []);

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  return (
    <Box 
      // className={classes.root}
      sx={{width:"98%", height:"65vh", margin:"1em"}}
    >
      <CreateSwarmsFilters
        filters={filters}
        setFilters={setFilters}
        onSearch={onSearch}
        paginationModel={paginationModel}
        onUnhideEvents={onShowHideEventClicked}
        localEvents={localEvents}
      />

    <BorderPopover
      id="simple-popover"
      open={showRunID}
      anchorEl={anchorEl}
      onClose={getRunID}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <div style={{padding:'0.5em', display:'flex'}}>
        <p style={{ fontWeight: "600", whiteSpace: "nowrap" }}>
          Run ID: {runId}
        </p>
        <button
          style={{backgroundColor: 'transparent', cursor: 'pointer', border: 'none', marginLeft:'1em'}}
          onClick={async () =>
            await copyToClipBoard(runId ? runId : "-- ERROR --")
          }
        >
          <img src={copyIcon} alt="copy icon" height="18px" width="18px" />
        </button>    
      </div>
    </BorderPopover>

    <div style={{ width: '98%', height: '65vh', position: 'relative' }}>
      
      {(loadingEvents && !swarmEventsRes && (paginationModel.pageSize === 250 || paginationModel.pageSize === 500)) && (
        <div style={{position: 'absolute', top: '57%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center', fontSize: '1.25em', fontWeight: 600, color:'var(--orange)', zIndex: 1}}>
          Shaking the hive, please wait.
        </div>
      )}

      {/* SwarmEditModal - will be opened with the Autobuy tab when SmartToyOutlinedIcon is clicked */}
      {isModalOpen && selectedSwarm && (
        <SwarmEditModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          bteId={selectedSwarm.bteId}
          swarmProp={selectedSwarm}
          initialTabIndex={1} // Set to index 1 to open the Autobuy tab by default
        />
      )}

      <DataGridPremium
        rows={rows}
        columns={getColumns()}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={handleProcessRowUpdateError}
        onRowModesModelChange={handleRowModesModelChange}
        rowModesModel={rowModesModel}
        editMode="row"
        rowHeight={36}
        headerHeight={40}
        sx={{width:"98%", height:"65vh", margin:0}}
        loading={loadingEvents && !swarmEventsRes}
        getRowId={r => r.bteId}
        hideFooterSelectedRowCount
        pagination
        disableColumnSelector
        disableMultipleRowSelection
        page={paginationModel.page}
        pageSize={paginationModel.pageSize}
        rowCount={swarmEventsRes?.totalCount || 0}
        paginationModel={paginationModel}
        onPaginationModelChange={v => { setPaginationModel(v); onSearch(filters, v) }}
        columnVisibilityModel={{
          EditedEntityLink:false,
          NewEntityLink:false,
          newSalesDates: false
        }}
        paginationMode="server"
        onColumnResize={handleColumnResize}
        pageSizeOptions={[25, 50, 100, 250, 500]} 
      />
      
    </div>
    
    </Box>
  );
}
